// @core/api/endpoints/webhook/list_deliveries.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDeliveriesResponse,
} from '../../../types/webhook';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/webhook';

/**
 * List webhook deliveries
 * Returns the delivery history for a webhook endpoint with filtering by status, event type, and date range.
 */
export async function ListDeliveries(
  endpoint_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListDeliveriesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/endpoints/:endpoint_id/deliveries`;
  requestPath = requestPath.replace(':endpoint_id', encodeURIComponent(endpoint_id));
  const requestOptions = options;
  return client.get<ListDeliveriesResponse>(requestPath, { ...requestOptions, params });
}
